import React from 'react'
import { Skeleton } from '@mui/material'

import { useToast } from '@hooks'
import { BACKEND_APIS } from '@constants'
import { TitleWithPopover, AppTableSeeker } from "@components";
import { dateColumn, numColumn, nameColumn } from './columns'
import { useCustomersTableFilters } from "./@hooks";


export default function CustomersTable() {

    const { data, isLoading } = useCustomersTableFilters()
    const { showToast } = useToast()

    if ( isLoading ) return <Skeleton variant="rectangular" height={500} />
    if (!data.length) return <></>

    const columns = [
        numColumn('customerID', 'Customer ID'),
        nameColumn(),
        dateColumn(),
        numColumn('numUsers', 'Num Users', true),
        numColumn('numSites', 'Num Sites'),
        numColumn('numKeywords', 'Num Keywords'),
    ]

    return <AppTableSeeker
        data={data}
        title={<TitleWithPopover title="Customers Info" />}
        columns={columns}
        options={{
            tableBodyHeight: '600',
            onDownload: () => showToast.promiseExcel(`${BACKEND_APIS.MANAGEMENT}/customer/context-excel`),
            viewColumns: false
        }}
    />
}